import React, { useState } from "react";
import { useHfBranch } from "./useHfBranch";
import {
  addShot,
  getVaccineBrand,
  getVaccineByVid,
  getSopAggreement,
  getSopContraindiction,
  searchClientsVaccine,
  searchVaccinationsByVid,
} from "service";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { IVaccine, IVaccineBrand, ISop } from "types";
import { useModal } from "hooks/useModal";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { toast } from "sonner";

export interface IVaccineResponse {
  id: number;
  vid: string;
  user: number;
  vaccine: string;
  vaccine_id: number;
  created_on: string;
  created_by: string;
  shots: IVaccineShot[];
  status: string;
  health_facility: string;
  unregistered_health_facility: null;
  shots_taken: number;
  downloads: number;
  patient_name: string;
  patient_email: string;
  patient_ino_id: string;
  patient_profile_pic: string;
  patient_phone: string;
  location: number;
  gender: string;
  is_cowvaVerified: boolean;
  vaccine_category: string;
}
interface IVaccineShot {
  id: number;
  client: string;
  vaccine_name: string;
  vaccine_brand: string;
  vaccinated_on: string;
  vaccinated_by: string;
  next_vaccination_date: string;
  branch: string;
  vaccine_batch_number: string;
  vaccine_expiry_date: string;
  brand: string;
  route: string;
  branch_address: string;
  health_facility: string;
  sop_agreement_contraindications: boolean;
  sop_agreement_before_administration: boolean;
  recordaefis: any[];
  notes: any[];
}

interface IAddShotFormData {
  brand: number | null;
  vaccine_batch_number: string;
  route: string;
  vaccinated_on: string;
  next_vaccination_day: number;
  next_vaccination_day_interval: string;
  vaccine_expiry_date: string;
  branch: number | null;
  sop_agreement_contraindications: number[];
  sop_agreement_before_administration: number[];
}

//! new
interface IClientVaccine {
  id: number;
  vid: string;
  name: string;
  created_on: string;
  created_by: string;
  is_complete: boolean;
  health_facility: number;
  shots_taken: number;
  downloads: number;
  patient_name: string;
  vaccine: string;
}

interface IClientVaccineResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: IClientVaccine[];
}

// searched vaccination
// {
//   "id": 8569,
//   "vid": "INO3BCC81CE3D",
//   "patient_name": "Doe John",
//   "patient_email": "officialayscript@gmail.com",
//   "patient_ino_id": "INOBE781F18DA",
//   "created_on": "03-05-2025 06:41 PM",
//   "vaccine": "Covid-19 Vaccine",
//   "vaccine_id": "27",
//   "is_cowvaVerified": true,
//   "vaccine_category": "catch_up",
//   "advice_information": "Advice on AEFI reporting\nDelay tuberculin skin test at least four weeks after",
//   "qr_image": "https://inocul8-media-bucket.s3.amazonaws.com/assets/images/vaccination/2025-05-03/1746294073-vaccination_qr_8569.png",
//   "status": "incomplete",
//   "shots": [
//     {
//       "id": 13735,
//       "client": "Doe John",
//       "vaccine_name": "Tetanus vaccine",
//       "vaccine_brand": "Tetanus",
//       "vaccinated_on": "08-05-2025 12:00 AM",
//       "vaccinated_by": "Olasupo Ayomide",
//       "next_vaccination_date": "2026-03-04",
//       "branch": "Default Branch",
//       "vaccine_batch_number": "9000",
//       "vaccine_expiry_date": "2025-05-09",
//       "brand": "Tetanus",
//       "route": "intradermal",
//       "branch_address": "",
//       "health_facility": "AVaccine",
//       "sop_agreement_contraindications": true,
//       "sop_agreement_before_administration": true,
//       "recordaefis": [],
//       "notes": []
//     },
//     {
//       "id": 13734,
//       "client": "Doe John",
//       "vaccine_name": "Covid-19 Vaccine",
//       "vaccine_brand": "Janssen (Johnson and Johnson)",
//       "vaccinated_on": "06-05-2025 12:00 AM",
//       "vaccinated_by": "Olasupo Ayomide",
//       "next_vaccination_date": "2025-05-27",
//       "branch": "Default Branch",
//       "vaccine_batch_number": "1000",
//       "vaccine_expiry_date": "2025-05-13",
//       "brand": "Janssen (Johnson and Johnson)",
//       "route": "intramuscular",
//       "branch_address": "",
//       "health_facility": "AVaccine",
//       "sop_agreement_contraindications": true,
//       "sop_agreement_before_administration": true,
//       "recordaefis": [],
//       "notes": []
//     },
//     {
//       "id": 13733,
//       "client": "Doe John",
//       "vaccine_name": "Tetanus vaccine",
//       "vaccine_brand": "Diphtheria and Tetanus BE",
//       "vaccinated_on": "10-05-2025 12:00 AM",
//       "vaccinated_by": "Olasupo Ayomide",
//       "next_vaccination_date": "2025-07-19",
//       "branch": "Default Branch",
//       "vaccine_batch_number": "7070",
//       "vaccine_expiry_date": "2025-05-07",
//       "brand": "Diphtheria and Tetanus BE",
//       "route": "intramuscular",
//       "branch_address": "",
//       "health_facility": "AVaccine",
//       "sop_agreement_contraindications": true,
//       "sop_agreement_before_administration": true,
//       "recordaefis": [],
//       "notes": []
//     }
//   ]
// }
export interface ISearchedVaccinationResponse {
  id: number;
  vid: string;
  patient_name: string;
  patient_email: string;
  patient_ino_id: string;
  created_on: string;
  vaccine: string;
  vaccine_id: string;
  is_cowvaVerified: boolean;
  vaccine_category: string;
  advice_information: string;
  qr_image: string;
  status: string;
  shots: IVaccineShot[];
}

export function useContinuedVaccination() {
  const { branch, allBranchesOptions } = useHfBranch();
  const { isOpen, openModal, closeModal } = useModal();
  const [modalType, setModalType] = useState<"loading" | "success" | "error">(
    "loading"
  );
  const params = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const vaccineId = searchParams.get("vaccineId");

  const [clientInoId, setClientInoId] = useState<string>("");
  const [selectedClientVaccine, setSelectedClientVaccine] =
    useState<IClientVaccine | null>(null);
  const [vaccineInoId, setVaccineInoId] = useState<string>("");
  const [formData, setFormData] = useState<IAddShotFormData>({
    brand: null,
    vaccine_batch_number: "",
    route: "",
    vaccinated_on: "",
    next_vaccination_day: 0,
    next_vaccination_day_interval: "",
    vaccine_expiry_date: "",
    branch: null,
    sop_agreement_contraindications: [],
    sop_agreement_before_administration: [],
  });
  const queryClient = useQueryClient();

  //!
  // search client vaccines
  const {
    data: clientVaccineResponse,
    isLoading: isLoadingClientVaccine,
    error: clientsError,
  } = useQuery<IClientVaccineResponse>({
    queryKey: ["clients", clientInoId],
    queryFn: async () => {
      if (!branch) return { count: 0, next: null, previous: null, results: [] };
      const response = await searchClientsVaccine(clientInoId);
      return response;
    },
    enabled: !!clientInoId,
  });

  const clientVaccinesData: IClientVaccine[] =
    clientVaccineResponse?.results || [];

  // search vaccinations
  const {
    data: vaccinationData,
    isLoading: isLoadingVaccinationData,
    error: vaccinationError,
  } = useQuery<ISearchedVaccinationResponse>({
    queryKey: ["vaccination", selectedClientVaccine?.vid],
    queryFn: async () => {
      if (!selectedClientVaccine?.vid) {
        throw new Error("No vaccine VID provided");
      }
      const response = await searchVaccinationsByVid(selectedClientVaccine.vid);
      return response;
    },
    enabled: !!selectedClientVaccine?.vid,
  });

  // search vaccination details
  const {
    data: vaccinationDetails,
    isLoading: isLoadingVaccinationDetails,
    error: vaccinationDetailsError,
  } = useQuery<ISearchedVaccinationResponse>({
    queryKey: ["vaccination-details"],
    queryFn: async () => {
      if (!selectedClientVaccine?.vid) return [];
      const response = await searchVaccinationsByVid(selectedClientVaccine.vid);
      console.log("vaccination details", response);
      return response;
    },
    enabled: !!selectedClientVaccine?.vid,
  });

  // const {
  //   data: vaccinesData,
  //   isLoading: isLoadingVaccines,
  //   refetch,
  // } = useQuery<IVaccineResponse>({
  //   queryKey: ["vaccination-by-vid", params.vid || vaccineInoId, branch?.hfId],
  //   queryFn: async () => {
  //     const idToUse = params.vid || vaccineInoId;
  //     if (!idToUse || !branch?.hfId) throw new Error("Missing parameters");
  //     return await getVaccineByVid(idToUse, branch.hfId);
  //   },
  //   enabled: !!params.vid,
  //   retry: false,
  // });

  const { data: vaccineBrand, isPending: isLoadingVaccineBrand } =
    useQuery<IVaccineBrand>({
      queryKey: ["vaccine-brand", vaccineId],
      queryFn: async () => {
        if (!vaccineId || !branch?.hfId) throw new Error("Missing parameters");
        return await getVaccineBrand(branch!.hfId, Number(vaccineId));
      },
      enabled: !!vaccineId,
    });

  const { data: sopAggreementData, isLoading: isLoadingSopAggreement } =
    useQuery<ISop>({
      queryKey: ["sop-aggreement", branch?.hfId, vaccineId],
      queryFn: async () => {
        if (!vaccineId || !branch?.hfId) throw new Error("Missing parameters");

        return await getSopAggreement(branch!.hfId, Number(vaccineId));
      },
      enabled: !!vaccineId,
    });

  const { data: sopContradictionData, isLoading: isLoadingSopContraindiction } =
    useQuery<ISop>({
      queryKey: ["sop-contradiction", branch?.hfId, vaccineId],
      queryFn: async () => {
        if (!vaccineId || !branch?.hfId) throw new Error("Missing parameters");

        return await getSopContraindiction(branch!.hfId, Number(vaccineId));
      },
      enabled: !!vaccineId,
    });

  const { mutate: addShotMutation, isPending: isAddingShot } = useMutation({
    mutationFn: async () => {
      if (!branch?.hfId || !params.vid) return;

      const response = await addShot(branch?.hfId, params.vid, formData);
      return response;
    },
    onSuccess: async (data) => {
      await queryClient.invalidateQueries({
        queryKey: ["all-vaccinations", params.vid, branch?.hfId],
      });
      await queryClient.invalidateQueries({
        queryKey: ["vaccination-by-vid", params.vid, branch?.hfId],
      });
      toast.success("Shot added successfully");
      navigate(-1);
    },
    onError: (err: any) => {
      const errors = err.response?.data.errors;

      if (Array.isArray(errors)) {
        const errorMessages = errors.map((err) => err.detail).join(", ");
        toast.error(errorMessages);
      } else {
        toast.error("An unknown error occurred.");
      }
    },
  });

  const handleFetch = async () => {
    if (!clientInoId || !branch?.hfId || !selectedClientVaccine?.vid) return;

    setModalType("loading");
    openModal();

    // Wait for the query to complete by relying on query status
    if (isLoadingVaccinationData) {
      // Query is still loading, keep modal in loading state
      return;
    }

    if (vaccinationError || !vaccinationData) {
      setModalType("error");
    } else {
      setModalType("success");
    }
  };

  const handleAddShot = () => {
    addShotMutation();
  };

  const vaccineBrandArray =
    vaccineBrand?.results?.map((brand) => ({
      label: brand.name,
      value: brand.id,
    })) || [];

  const handleUpdateField = (
    field: keyof IAddShotFormData,
    value: string | number | boolean | number[] | string[] | boolean[]
  ) => {
    setFormData((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const handleUpdateSopField = (
    field: keyof IAddShotFormData,
    value: number
  ) => {
    setFormData((prevState) => {
      const updatedArray = prevState[field] as number[];

      return {
        ...prevState,
        [field]: updatedArray.includes(value)
          ? updatedArray.filter((item) => item !== value)
          : [...updatedArray, value],
      };
    });
  };

  const isFormComplete = () => {
    return (
      formData.brand &&
      formData.vaccine_batch_number &&
      formData.vaccinated_on &&
      formData.next_vaccination_day &&
      formData.next_vaccination_day_interval &&
      formData.vaccine_expiry_date &&
      formData.branch &&
      formData.sop_agreement_contraindications.length > 0 &&
      formData.sop_agreement_before_administration.length > 0
    );
  };

  return {
    clientVaccinesData,
    isLoadingClientVaccine,
    clientsError,
    selectedClientVaccine,
    setSelectedClientVaccine,
    clientInoId,
    setClientInoId,
    vaccinationDetails,
    isLoadingVaccinationDetails,
    vaccinationsData: vaccinationData,
    vaccineBrandArray,
    isLoadingVaccineBrand,
    vaccineInoId,
    isOpen,
    modalType,
    formData,
    allBranchesOptions,
    isAddingShot,
    sopAggreementData,
    sopContradictionData,
    setVaccineInoId,
    handleFetch,
    openModal,
    closeModal,
    handleUpdateField,
    handleUpdateSopField,
    isFormComplete,
    navigate,
    handleAddShot,
  };
}
